"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoCard = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
require("components/card/video/video");
require("components/timeline/animation-item/animation-item");
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper_1 = require("../../../../ReactCanWrapper");
require("./styles.less");
function VideoCard(props) {
    var options = new can_1.default.Map(tslib_1.__assign(tslib_1.__assign({}, props.options), { isGSCard: true }));
    var template = "<animation-item\n                        {timeline-type}=\"gs-timeline\"\n                        {is-embed}=\"false\"\n                        ><card-video\n                        timeline-type=\"gs-timeline\"\n                        {card}=\"card\"\n                        {(active-card)}=\"activeCard\"\n                        card-index=\"{{cardIndex}}\"\n                        isgscard=\"{{isGSCard}}\"\n                        ></card-video></animation-item>";
    return (React.createElement("div", { className: 'rating-row-wrapper' },
        React.createElement(ReactCanWrapper_1.ReactCanWrapper, { className: 'm-gs-timeline__card', options: options, template: template })));
}
exports.VideoCard = VideoCard;
